import axios from 'axios';
import store from '../store'

export default function setup() {
  axios.interceptors.request.use(function(config) {
    const url = config.url;
    if(!(url.includes( 'wompi.co' ) || url.includes( 'payulatam.com' ) || url.includes('mercadopago.js'))) {
      const customer_id = store.getters['customer/instance_id'];
      const supplier_id = store.getters['customer/supplier_id']
      const service = store.getters['order/service'];
      const subservice = store.getters['customer/subservice'];
      const lang = store.state.shared.lang;
      if(customer_id) config.headers.customer_id = `${customer_id}`;
      if(supplier_id) config.headers.supplier_id = `${supplier_id}`;
      if(service) config.headers.service = `${service}`;
      if(subservice) config.headers.subservice = `${subservice}`;
      if(lang) config.headers.lang = lang;
    }
      
      return config;
  }, function(err) {
      return Promise.reject(err);
  });
}
